import { useState } from 'react';
import { faqs } from '@/mocks/chigua';

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-white py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold tracking-widest text-leaf-600 uppercase">
            <i className="ri-question-answer-line"></i> FAQ
          </span>
          <h2 className="mt-3 font-display font-bold text-3xl md:text-5xl text-ink">常见问题解答</h2>
          <p className="mt-3 text-sm md:text-base text-ink/60">关于投票、打榜与助力，这里有你关心的全部答案。</p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((f, idx) => {
            const open = openIdx === idx;
            return (
              <div key={idx} className={`rounded-2xl border transition-colors ${open ? 'border-melon-200 bg-melon-50/50' : 'border-ink/10 bg-canvas'}`}>
                <button
                  onClick={() => setOpenIdx(open ? -1 : idx)}
                  className="w-full flex items-center justify-between gap-4 text-left px-5 md:px-6 py-4 cursor-pointer"
                >
                  <h3 className="font-bold text-base md:text-lg text-ink">{f.q}</h3>
                  <span className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center text-melon-500 bg-white transition-transform ${open ? 'rotate-45' : ''}`}>
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                {open && (
                  <div className="px-5 md:px-6 pb-5 -mt-1 text-sm md:text-base text-ink/70 leading-relaxed">
                    {f.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}